define(
({
  "load_error": "Errore di Caricamento",
  "description": "Una richiesta non è stata completata correttamente. Assicurati di aver salvato il tuo ordine e aggiorna la pagina."
})
);
